import { AppLocaleMessageObject, LocaleOptions } from "@/plugins/i18n/types";

const BaseMessages: AppLocaleMessageObject = {
  home: {
    welcome: "Welcome",
    liveChannelsHeading: "Live Channels",
    watchNow: "watchNow"
  },
  sidebar: {
    home: "Home",
    channels: "Live / Channels",
    buffet: "Buffet EPG",
    settings: "Settings",
    vod: "VoD Library"
  },
  buffet: {
    datesFilter: {
      today: "Today",
      yesterday: "Yesterday",
      tomorrow: "Tomorrow"
    },
    epgCard: {
      play: "Play",
      epg: "EPG",
      info: "Info"
    }
  },
  channelsPage: {
    nowOnTV: "Now On TV",
    channels: "Channels",
    infoPage: {
      play: "Play"
    },
    epgCard: {
      play: "Play",
      epg: "EPG",
      info: "Info"
    },
    channelCard: {
      play: "Play",
      epg: "EPG",
      add: "Add"
    }
  },
  categoriesEnum: {
    allChannels: "All Channels",
    favorites: "Favorites"
  },
  buffetCategoriesEnum: {
    home: "Home"
  },
  vodPage: {
    types: {
      movies: "Movies",
      tvShows: "TV Shows"
    },
    vodCard: {
      play: "Play",
      info: "Info",
      add: "Add"
    }
  },
  settings: {
    title: "Review Your",
    subTitle: "Settings",
    profileSectionTitle: "Profile:",
    personalSectionTitle: "Personal:",
    otherSectionTitle: "Other:",
    cardsPersonal: {
      logout: "Logout",
      restart: "Restart",
      language: {
        heading: "Choose",
        subHeading: "Language"
      },
      pin: {
        heading: "Change",
        subHeading: "Lock Pin"
      }
    },
    cardsOther: {
      sortAndLock: {
        heading: "Sort and Lock",
        subHeading: "Channels"
      },
      support: {
        heading: "Support, About App",
        subHeading: "General info",
        headingRightSideMenu: "Support"
      }
    },
    cardsProfile: {
      btnEdit: "Edit",
      btnDelete: "Delete",
      user: {
        profile: "Profile",
        child: "Child"
      },
      addNew: {
        addChild: "Add Child",
        createNew: "Create new"
      }
    },
    rightSideMenu: {
      logoutBtn: "Logout",
      restartBtn: "Restart",
      oldPinInput: "Enter Old PIN*",
      newPinInput: "Enter New PIN*",
      confirmNewPinInput: "Please re-enter new PIN",
      confirmPinBtn: "Confirm",
      contactUs: "Contact us at:"
    },
    confirmModal: {
      userDelete: "Are you sure you want to delete the user?",
      backToSettings: "Are you sure you want to go back to Settings?",
      yes: "Yes",
      no: "no"
    },
    pinModal: {
      confirmPinText: "Please enter PIN code",
      pinInput: "Your PIN here",
      confirmBtn: "Confirm"
    },
    editUserForm: {
      username: "* Username / Profile name:",
      name: "* Name",
      lastName: "* Last Name",
      email: "* Email",
      phone: "* Phone",
      oldPass: "* Old Password",
      password: "* Password",
      confirmPass: "* Confirm Password",
      oldPin: "* Enter old PIN",
      pin: "* PIN code",
      confirmPin: " * Confirm PIN",
      saveBtn: "Save",
      title: "Edit user",
      subTitle: "Profile"
    },
    sortAndLock: {
      title: "Sort and Lock",
      subTitle: "Channels",
      cardLock: "Lock",
      cardUnlock: "Unlock",
      cardSort: "Sort",
      cardAdd: "Add",
      cardRemove: "Remove"
    }
  },
  overlay: {
    backBtn: "Back",
    contentNext: {
      later: "Later",
      upNext: "Up next",
      nextEpisodeBtn: "Watch next Episode"
    }
  }
};

const EN: LocaleOptions = {
  BaseMessages
};

export default EN;
